import { render, staticRenderFns } from "./alarm_detail.vue?vue&type=template&id=954924d0"
import script from "./alarm_detail.vue?vue&type=script&lang=js"
export * from "./alarm_detail.vue?vue&type=script&lang=js"
import style0 from "./alarm_detail.vue?vue&type=style&index=0&id=954924d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports